import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

// Create a separate axios instance for public API (no auth required)
const publicApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface CreatePaymentIntentRequest {
  questionnaire_token: string;
}

export interface CreatePaymentIntentResponse {
  client_secret: string;
  amount: number;
  currency: string;
  payment_id: number;
}

export interface StripeConfigResponse {
  publishable_key: string;
}

export const paymentService = {
  /**
   * Get Stripe publishable key for frontend
   */
  async getConfig(): Promise<StripeConfigResponse> {
    const response = await publicApi.get<StripeConfigResponse>('/public/payments/config');
    return response.data;
  },

  /**
   * Create a Stripe PaymentIntent for a questionnaire.
   * The amount is calculated server-side - frontend only provides the token.
   */
  async createIntent(questionnaireToken: string): Promise<CreatePaymentIntentResponse> {
    const response = await publicApi.post<CreatePaymentIntentResponse>(
      '/public/payments/create-intent',
      { questionnaire_token: questionnaireToken }
    );
    return response.data;
  },
};
